<style>
   .icon {
     cursor:pointer
   }   
</style>
  
<svg class="icon" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
  <path id="Path_209" data-name="Path 209" d="M16,1A15,15,0,1,0,31,16,15.007,15.007,0,0,0,16,1Zm0,2A13,13,0,1,1,3,16,13.006,13.006,0,0,1,16,3Z" transform="translate(-1 -1)" fill-rule="evenodd"/>
  <path id="Path_210" data-name="Path 210" d="M21.293,12.293,16,17.586l-5.293-5.293a1,1,0,0,0-1.414,1.414l6,6a1,1,0,0,0,1.414,0l6-6a1,1,0,1,0-1.414-1.414Z" transform="translate(-1 -1)" fill-rule="evenodd"/>
</svg>
